import { get, post } from '@/services/API';

export default {
  getMediniDelivery: () => get('/api/delivery/medini'),
  saveIncompleteProducts: (deliveries) => post('/api/delivery/incomplete', deliveries),
};
